"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovableBuilderOwnerModelAsset = void 0;
const zod_1 = require("zod");
const utils_1 = require("../utils");
const enums_1 = require("./enums");
const location_1 = require("./subschemas/location");
const propertyDetails_1 = require("./subschemas/propertyDetails");
const descriptions_1 = require("./subschemas/descriptions");
const documents_1 = require("./subschemas/documents");
const conditional_field_map_1 = require("./refinements/conditional-field-map");
const revenue_pool_1 = require("../revenue-pool/revenue-pool");
exports.ApprovableBuilderOwnerModelAsset = zod_1.z
    .object({
    type: zod_1.z.enum(utils_1.availableAssetTypes),
    descriptions: descriptions_1.DescriptionValidationSchema.pick({
        title: true,
        propertySellingPoints: true,
        propertyHighlight: true,
        propertyDetails: true,
        propertyQuote: true,
        locationDetails: true,
        districtDetails: true,
        cityDetails: true,
        rentalDetails: true,
        investmentDetails: true,
        investmentDetailsAddition: true,
        securityDetails: true,
        overview: true,
    }),
    location: location_1.LocationValidationSchema.pick({
        countryCode: true,
        city: true,
        postalCode: true,
        address: true,
        coordinates: true,
    }),
    propertyDetails: propertyDetails_1.PropertyDetailsValidationSchema.pick({
        size: true,
        buildingCondition: true,
        propertyType: true,
        heatingType: true,
        carbonEmission: true,
        energyEmission: true,
        constructionStatus: true,
        expectedBuildingStartDate: true,
        highlights: true,
    })
        .extend({
        // different 'features' type for request
        features: zod_1.z.array(utils_1.mongoDBObjectIdSchema),
    })
        .partial(),
    // TODO: pick type
    rentalDetails: zod_1.z
        .object({
        payoutInterval: zod_1.z.nativeEnum(enums_1.TPayoutInterval).optional(),
        contractType: zod_1.z.nativeEnum(enums_1.TContractType),
        contractStartDate: zod_1.z.coerce.date().optional(),
        contractEndDate: zod_1.z.coerce.date().optional(),
        expectedRentalStartDate: zod_1.z.coerce.date().nullable().default(null),
        occupancyRate: zod_1.z.number().optional(),
        monthlyDistributionDate: zod_1.z.number(),
        rentalIncome: zod_1.z.number(),
        rentalSurplus: zod_1.z.number(),
        rentalReturn: zod_1.z.number(),
        managementFee: zod_1.z.number(),
        liquidityReserve: zod_1.z.number(),
        plannedFirstRentalIncomeDate: zod_1.z.coerce.date().optional(),
        revenuePool: zod_1.z.union([zod_1.z.string(), revenue_pool_1.RevenuePoolSchema]).optional(),
    })
        .refine((data) => {
        if (data.contractType === enums_1.TContractType.closed && !data.contractEndDate)
            return false;
        return true;
    }, {
        message: 'The contract type is closed, but no end date was provided.',
    })
        .refine((data) => {
        if (data.contractType === enums_1.TContractType.open &&
            data.contractEndDate &&
            data.contractStartDate &&
            data.contractEndDate > data.contractStartDate)
            return false;
        return true;
    }, {
        message: 'The contract end date can not be earlier than the start date.',
    }),
    // TODO: pick type
    investmentDetails: zod_1.z
        .object({
        stage: zod_1.z.nativeEnum(enums_1.TAssetStage),
        sharePrice: zod_1.z.number(),
        totalBricks: zod_1.z.number().min(1),
        expertRating: zod_1.z.number().min(0).max(5).optional(),
        appraisalFirm: zod_1.z.string().optional(),
        ISIN: zod_1.z.string().max(12),
        spv: zod_1.z.string(),
        issueStartDate: zod_1.z.coerce.date(),
        issueEndDate: zod_1.z.coerce.date(),
        issueFundingFloor: zod_1.z.number(),
        securityType: zod_1.z.nativeEnum(enums_1.TSecurityType),
        landRegisterMortgageStatus: zod_1.z.boolean().optional(),
        landRegisterMortgageStatusText: zod_1.z.string().optional(),
        landRegisterMortgageDescription: zod_1.z.string().optional(),
        minSubscriptionAmount: zod_1.z.number().max(100),
        forumActive: zod_1.z.boolean().optional(),
        totalConstructionVolume: zod_1.z.number(),
        totalConstructionVolumeNote: zod_1.z.string(),
        publicFunding: zod_1.z.number(),
        publicFundingNote: zod_1.z.string(),
        brokerageFeeForEndCustomers: zod_1.z.boolean(),
        accountName: zod_1.z.string(),
        iban: zod_1.z.string(),
        bic: zod_1.z.string(),
        companyName: zod_1.z.string(),
        companyDescription: zod_1.z.string(),
        yield: zod_1.z.number(),
        yieldIntroductoryText: zod_1.z.string(),
        yieldFieldname: zod_1.z.string(),
        yieldInfoIcon: zod_1.z.string(),
    })
        .refine((data) => {
        if (data.sharePrice < 1)
            return false;
        return true;
    }, { message: 'Share price must be greater than 1' }),
    images: zod_1.z.object({
        propertyPhotos: zod_1.z.array(enums_1.ImageValidationSchema).nonempty(),
        locationPhotos: zod_1.z.array(enums_1.ImageValidationSchema).nonempty(),
    }),
    documents: documents_1.DocumentsValidationSchema.pick({
        investmentBasicInformation: true,
        investmentInformation: true,
        investmentConditions: true,
        rentalAgreement: true,
        expertProtocol: true,
        landRegister: true,
        energyCertificate: true,
        utilityReport: true,
        additionalDocuments: true,
        additionalInvestmentDocuments: true,
        scenarioCalculations: true,
    }),
})
    .superRefine(conditional_field_map_1.refineConditionalFields);
//# sourceMappingURL=builderOwnerModelAsset.js.map